export const environment = {
  production: true,
  // api: "https://localhost:7024/api/",
  api: "https://www.apicentrovisionsl.somee.com/api/",
};